import create from 'zustand';
import { IPackageDetail } from '@root/types/package';
import { ILoading } from '@root/types/common';

export interface IState {
  detail: IPackageDetail;
  id: string;
  updateTime: number;
  loading: ILoading;
  setDetail: (v: IPackageDetail, id: string) => void;
  setLoading: (v: ILoading) => void;
  resetInitData: () => void;
}

const useSubscriptionDetail = create<IState>((set) => ({
  detail: {} as IPackageDetail,
  id: '',
  updateTime: 0,
  loading: -1,
  setLoading: (loading) => {
    return set(() => {
      return {
        loading,
      };
    });
  },
  setDetail: (detail: IPackageDetail, id: string) => {
    return set(() => {
      return {
        updateTime: new Date().getTime(),
        id,
        detail,
      };
    });
  },
  resetInitData: () => {
    return set(() => {
      return {
        loading: -1,
        detail: {} as IPackageDetail,
        updateTime: 0,
        id: '',
      };
    });
  },
}));

export default useSubscriptionDetail;
